import React, { useEffect, useState, useRef } from 'react';
import s from './Toast.module.sass';

const Toast = ({ id, type, message, duration = 2000, onClose }) => {
    const [isVisible, setIsVisible] = useState(true);
    const [isRemoving, setIsRemoving] = useState(false);
    const timeoutRef = useRef(null);
    const closeTimeoutRef = useRef(null);

    useEffect(() => {
        // Автоматически скрываем тост после указанной длительности
        timeoutRef.current = setTimeout(() => {
            setIsRemoving(true);
            setIsVisible(false);
            // Даем время на анимацию исчезновения перед удалением из DOM
            closeTimeoutRef.current = setTimeout(() => {
                onClose();
            }, 350); // Время анимации исчезновения
            }, duration);

        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            if (closeTimeoutRef.current) clearTimeout(closeTimeoutRef.current);
        };
    }, [duration, onClose]);

    const handleClose = () => {
        if (isRemoving) return; // Предотвращаем двойное закрытие
        setIsRemoving(true);
        setIsVisible(false);
        // Даем время на анимацию исчезновения перед удалением из DOM
        closeTimeoutRef.current = setTimeout(() => {
            onClose();
        }, 350);
    };

    const getIcon = () => {
        switch (type) {
            case 'success':
                return '✅';
            case 'error':
                return '❌';
            case 'warning':
                return '⚠️';
            case 'info':
                return 'ℹ️';
            default:
                return 'ℹ️';
        }
    };

    return (
        <div className={`${s.toast} ${s[type]} ${isVisible ? s.show : s.hide}`} data-ltr-force>
                <div className={s.toastContent}>
                    <div className={s.toastIcon}>
                        {getIcon()}
                    </div>
                    <div className={s.toastMessage}>
                        {message}
                    </div>
                    <button 
                        className={s.toastClose}
                    onClick={handleClose}
                        aria-label="Закрыть уведомление"
                    disabled={isRemoving}
                    >
                        ✕
                    </button>
            </div>
        </div>
    );
};

export default Toast;